import styled from "styled-components";
import { darken } from "polished";
import { mobileOnly } from "_/style/media";
import { pagePadding } from "_/style/layout";
import { TextField } from "_/components/text-field";

export const Wrapper = styled.div`
  height: 100%;
`;

export const Nav = styled.nav`
  display: flex;
  justify-content: start;
  margin-bottom: 1.5rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${(p) => p.theme.subheader.background};
  padding: 1rem 2.5rem 0 2.5rem;

  nav {
    margin-bottom: 0;
  }
  ${mobileOnly`
    nav {
      overflow-x: auto;
    }
    padding: 1rem;;
  `}
`;

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  background-color: ${(p) => p.theme.subheader.background};
  border-bottom: 1px solid ${(p) => p.theme.subheader.border};

  & h1 {
    font-size: 1.75rem;
    margin-bottom: 0;
    margin-top: 0;
  }
  ${pagePadding};
  padding-bottom: 1.5rem;
  padding-top: 2rem;
`;

export const TextFieldWrapper = styled.div`
  margin-bottom: 12px;
`;

/** Inline search box that sits beside a section heading. */
export const SearchField = styled(TextField)`
  width: 100%;
  max-width: 20rem;
`;

export const AdminContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  & p {
    padding-bottom: 1rem;
  }
  ${pagePadding};
`;

export const AdminContentSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 1rem;
`;

export const AdminContentSectionTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  h2 {
    margin: 0;
    padding: 0 0 0 1px;
    line-height: 1;
  }
`;

export const AdminContentSectionTitleButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
`;

export const MaterialColorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-transform: uppercase;
  font-size: 15px;

  // 'visibility: hidden' and 'display: none' both prevent tab navigation from
  // focussing on the input element, so we make it invisible instead.
  & input[type="color"] {
    opacity: 0;
    height: 0;
    width: 0;
    border: none;
    color-scheme: ${(p) => p.theme.input.colorScheme};
    pointer-events: none;
  }
`;

export const MaterialColorBox = styled.div.attrs<{ $color: string }>((p) => ({
  // The use of `style` is based on the styled-components console output below:
  // >  Over 200 classes were generated for component MaterialColorBox with the
  // >  id of "MaterialColorBox-sc-g61vsi-15".  Consider using the attrs method,
  // >  together with a style object for frequently changed styles.
  style: {
    borderColor: darken(0.1, p.$color),
    backgroundColor: p.$color,
  },
}))`
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  width: 1rem;
  height: 1rem;
  border-radius: 2px;
`;

export const MaterialColorFormFieldContainer = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  border: 1px solid ${(p) => p.theme.input.default.border};
  border-radius: 2px;

  transition: border 0.1s ease;

  &:focus-within {
    border-color: ${(p) => p.theme.input.focused.border};
  }
`;

export const SideBySide = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

export const ControlLabel = styled.span`
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.muted};
`;

export const CheckboxField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

/** Help text under a checkbox, aligned with its label (1rem box + 0.5rem gap). */
export const CheckboxHint = styled.span`
  padding-left: 1.5rem;
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.muted};
`;

export const Checkmark = styled.span`
  margin-left: 1rem;
`;

export const ArchiveMessage = styled.div`
  margin-bottom: 1rem;
`;

export const ErrorMessage = styled.div`
  color: ${(p) => p.theme.input.invalid.text};
  padding: 2rem 0;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 2rem;
`;

const OneFilter = styled.div`
  display: flex;
  gap: 1rem;
  flex-shrink: 0;
  place-items: center;
  font-size: 0.875rem;

  & .react-select__placeholder,
  & .react-select__dropdown-indicator,
  & .react-select__clear-indicator {
    color: ${(p) => p.theme.text.muted};
    &:hover {
      color: ${(p) => p.theme.text.default};
    }
  }
`;

export const OneFilterSerialNumber = styled(OneFilter)`
  & .react-select__control {
    min-width: 150px;
  }
`;

export const OneFilterOrg = styled(OneFilter)`
  & .react-select__control {
    min-width: 300px;
  }
`;
